import React from "react";
import { DASHBOARD_FIELD_ERROR_CLASS } from "../InputField/dashboardFieldClassNames";

/**
 * Dashboard validation / error text — 11px max.
 */
const DashboardFieldError = ({ as: Tag = "span", children, className = "", ...rest }) => {
  if (!children) return null;

  return (
    <Tag className={`${DASHBOARD_FIELD_ERROR_CLASS} mt-1 ${className}`.trim()} {...rest}>
      {children}
    </Tag>
  );
};

export default DashboardFieldError;
